<script setup lang="ts">
import { Component } from "vue";

type IProps = {
  title: string;
  buttons?: Component[];
  accounts?: string[];
};

const props: IProps = withDefaults(defineProps<IProps>(), {});
</script>

<template>
  <div class="w-full min-h-[86px] relative bg-white rounded-2xl shadow">
    <div class="mx-6 flex flex-col lg:flex-row lg:justify-between lg:items-center h-full py-4 gap-4">
      <div class="text-zinc-800 text-2xl md:text-3xl lg:text-4xl font-bold font-['Sora'] flex items-center">
        {{ props.title }}
      </div>
      <div class="flex flex-wrap justify-start lg:justify-end items-center gap-3">
        <slot name="buttons" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
